import { connect } from 'react-redux';

import SidebarComponent from './Sidebar';

const Sidebar = connect(
  (state) => ({ isAdminUser: state.identity.user.isAdmin })
)(SidebarComponent);

export default Sidebar;
